import { dbDel, dbPut } from '../core/db.js';
import { cardsOfCourse, cardsOfDeck, scopeLabel, scopedCards } from '../core/load.js';
import { state } from '../core/state.js';
import { $, $$, clozeAnswers, esc, fmtDue, fmtDur, stripMarkup } from '../core/text.js';
import { streakDays } from '../progress/streak.js';
import { cardModal } from '../study/editor.js';
import { LEVEL_NAME, toast } from '../ui/toast.js';
import { refresh } from '../ui/views.js';
import { allActiveCards } from './dashboard.js';

/* ══════════ Statistik ══════════ */
export function renderStats() {
  const cards = allActiveCards();
  const totalMs = state.log.reduce((s, l) => s + l.ms, 0);
  const totalReps = cards.reduce((s, c) => s + c.reps, 0);
  const avgMs = totalReps ? cards.reduce((s, c) => s + c.totalMs, 0) / totalReps : 0;
  const learnedDays = state.log.filter((l) => l.count > 0).length;
  $('#stat-tiles').innerHTML = `
    <div class="stat-tile"><div class="stat-num">${fmtDur(totalMs)}</div><div class="stat-lbl">Lernzeit gesamt</div></div>
    <div class="stat-tile"><div class="stat-num">${(avgMs / 1000).toFixed(1)} s</div><div class="stat-lbl">⌀ pro Frage</div></div>
    <div class="stat-tile"><div class="stat-num">${totalReps}</div><div class="stat-lbl">Antworten</div></div>
    <div class="stat-tile"><div class="stat-num">${learnedDays}</div><div class="stat-lbl">Lerntage</div></div>
    <div class="stat-tile"><div class="stat-num">${streakDays()}</div><div class="stat-lbl">Serie</div></div>`;
  const barList = (rows) => {
    if (!rows.length) return '<p class="page-sub">Noch keine Daten.</p>';
    const max = Math.max(...rows.map((r) => r.ms), 1);
    return rows.sort((a, b) => b.ms - a.ms).map((r) => `
      <div class="stat-row">
        <div class="stat-row-head"><b>${esc(r.name)}</b><span>${fmtDur(r.ms)} · ⌀ ${(r.avg / 1000).toFixed(1)} s</span></div>
        <div class="stat-bar"><i style="width:${Math.round((r.ms / max) * 100)}%"></i></div>
      </div>`).join('');
  };
  $('#stat-courses').innerHTML = barList(state.courses.filter((c) => !c.archived).map((c) => {
    const cc = cardsOfCourse(c.id), ms = cc.reduce((s, x) => s + x.totalMs, 0), reps = cc.reduce((s, x) => s + x.reps, 0);
    return { name: c.name, ms, avg: reps ? ms / reps : 0 };
  }).filter((r) => r.ms > 0));
  $('#stat-decks').innerHTML = barList(state.decks.filter((d) => !d.archived).map((d) => {
    const dc = cardsOfDeck(d.id), ms = dc.reduce((s, x) => s + x.totalMs, 0), reps = dc.reduce((s, x) => s + x.reps, 0);
    const course = state.courses.find((c) => c.id === d.courseId);
    return { name: `${course?.name || '?'} › ${d.name}`, ms, avg: reps ? ms / reps : 0 };
  }).filter((r) => r.ms > 0));
  const slow = cards.filter((c) => c.reps >= 2).sort((a, b) => b.totalMs / b.reps - a.totalMs / a.reps).slice(0, 8);
  $('#stat-slow').innerHTML = slow.length ? slow.map(miniCard).join('') : '<div class="empty">Noch zu wenig gelernt.</div>';
  wireMiniCards();
}

/* ══════════ Kartenliste ══════════ */
export function miniCard(c) {
  const deck = state.decks.find((d) => d.id === c.deckId);
  const course = state.courses.find((x) => x.id === c.courseId);
  const thumb = c.front.image || c.back.image;
  const rate = c.reps ? Math.round((c.wrong / c.reps) * 100) : 0;
  return `<div class="mini-card lvl-${c.level} pc-${c.color}">
    <div class="mini-swatch"></div>
    ${thumb ? `<img class="mini-thumb" src="${thumb}" alt="">` : ''}
    <div class="mini-body">
      <div class="mini-q">${esc(stripMarkup(c.front.text)) || '<em>(nur Bild)</em>'}</div>
      <div class="mini-a">${c.cloze ? `<em>Lückentext · ${esc(clozeAnswers(c.front.text)) || '—'}</em>` : (esc(stripMarkup(c.back.text)) || '<em>(nur Bild)</em>')}</div>
      <div class="mini-deck">${esc(course?.name || '?')} › ${esc(deck?.name || '–')}
        · ${LEVEL_NAME[c.level]} · ${fmtDue(c)}${c.reps ? ` · ${c.reps}× geübt, ${rate}% daneben` : ' · neu'}${(c.tags && c.tags.length) ? ' · ' + c.tags.map((t) => '#' + esc(t)).join(' ') : ''}</div>
    </div>
    <div class="mini-actions">
      <button class="mini-btn ${c.fav ? 'on' : ''}" data-fav-card="${c.id}" title="Favorit">${c.fav ? '★' : '☆'}</button>
      <button class="mini-btn ${c.later ? 'on' : ''}" data-later-card="${c.id}" title="Später">⏰</button>
      <button class="mini-btn" data-edit-card="${c.id}" title="Bearbeiten">✎</button>
      <button class="mini-btn del" data-del-card="${c.id}" title="Löschen">✕</button>
    </div>
  </div>`;
}
export function wireMiniCards() {
  $$('[data-edit-card]').forEach((el) => { el.onclick = () => cardModal(state.cards.find((c) => c.id === el.dataset.editCard)); });
  $$('[data-del-card]').forEach((el) => {
    el.onclick = async () => {
      await dbDel('cards', el.dataset.delCard);
      state.cards = state.cards.filter((c) => c.id !== el.dataset.delCard);
      toast('Karte gelöscht'); refresh();
    };
  });
  $$('[data-fav-card]').forEach((el) => {
    el.onclick = async () => { const c = state.cards.find((x) => x.id === el.dataset.favCard); c.fav = !c.fav; await dbPut('cards', c); refresh(); };
  });
  $$('[data-later-card]').forEach((el) => {
    el.onclick = async () => { const c = state.cards.find((x) => x.id === el.dataset.laterCard); c.later = !c.later; await dbPut('cards', c); refresh(); };
  });
}
export const emptyState = (msg) => `<div class="empty"><img class="empty-img" src="assets/cat_study.png" alt=""><span>${esc(msg)}</span></div>`;

export function renderCards() {
  $('#btn-new-card').disabled = !state.selCourse;
  const list = $('#card-list');
  const q = (state.search || '').toLowerCase();
  // Ohne ausgewählten Kurs trotzdem suchen können = kursübergreifende Suche.
  const global = !state.selCourse && (!!q || !!state.tagFilter);
  $('#cards-sub').textContent = global ? 'Suche über alle Kurse' : scopeLabel();
  if (!state.selCourse && !global) {
    list.innerHTML = emptyState('Wähle links einen Kurs – oder tippe oben, um über alle Karten zu suchen.');
    renderTagChips([]); return;
  }
  let cards = state.selCourse ? scopedCards() : state.cards.slice();
  renderTagChips(cards);
  if (state.filter === 'fav') cards = cards.filter((c) => c.fav);
  else if (state.filter === 'later') cards = cards.filter((c) => c.later);
  else if (state.filter !== 'all') cards = cards.filter((c) => c.level === state.filter);
  if (state.tagFilter) cards = cards.filter((c) => (c.tags || []).includes(state.tagFilter));
  if (q) cards = cards.filter((c) => (stripMarkup(c.front.text) + ' ' + stripMarkup(c.back.text) + ' ' + (c.hint || '') + ' ' + (c.tags || []).join(' ')).toLowerCase().includes(q));
  list.innerHTML = cards.length ? cards.map(miniCard).join('') : emptyState('Nichts gefunden.');
  wireMiniCards();
}
export function renderTagChips(cards) {
  const box = $('#tag-chips'); if (!box) return;
  const counts = {};
  cards.forEach((c) => (c.tags || []).forEach((t) => { counts[t] = (counts[t] || 0) + 1; }));
  const tags = Object.keys(counts).sort((a, b) => counts[b] - counts[a]).slice(0, 24);
  if (!tags.length && !state.tagFilter) { box.innerHTML = ''; box.style.display = 'none'; return; }
  box.style.display = '';
  box.innerHTML = tags.map((t) => `<button class="tchip ${state.tagFilter === t ? 'active' : ''}" data-tag="${esc(t)}">#${esc(t)} <small>${counts[t]}</small></button>`).join('')
    + (state.tagFilter ? `<button class="tchip clear" data-tag="">✕ Tag-Filter</button>` : '');
  box.querySelectorAll('[data-tag]').forEach((el) => { el.onclick = () => { state.tagFilter = el.dataset.tag || null; renderCards(); }; });
}

